import { render, staticRenderFns } from "./ModalTracking.vue?vue&type=template&id=a890dce4&"
import script from "./ModalTracking.vue?vue&type=script&lang=js&"
export * from "./ModalTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports